import { render } from "./WidgetBmbLinkanzeige.vue?vue&type=template&id=0cb68b60&scoped=true&ts=true"
import script from "./WidgetBmbLinkanzeige.vue?vue&type=script&lang=ts"
export * from "./WidgetBmbLinkanzeige.vue?vue&type=script&lang=ts"

import "./WidgetBmbLinkanzeige.vue?vue&type=style&index=0&id=0cb68b60&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb68b60"]])

export default __exports__